<!-- travel-order -->

<template>
  <div class="enter-order-page">
    <van-form ref="orderForm" @submit="orderFormOnSubmit">
      <div class="content-box">

        <div style="background-color: #fff;border-radius: 4px;padding: 16px;">
          <div style="font-size: 21px; color: #585858;font-weight: bold">
            {{ goodsInfo.name }}
          </div>

          <span style="color: #333;display: flex;margin-top: 8px;font-size: 13px;">
            <span id="J_description" class="m-content overflow-line" style="">
              {{ noteInfo }}
            </span>
            <a v-if="isShowMore" id="J_btnmore" class="btn-more" @click="showMoreDesc($event)">展开</a>
          </span>

          <van-tag v-for="tag of goodsInfo.tags" :key="tag" color="#0086f6" size="medium"
            style="margin-right: 8px;display: inline-block;margin-top: 8px;">
            {{ tag }}
          </van-tag>

          <div style="font-size: 12px;color: #999999;display: inline-block;margin-left: 16px;" @click="showNotice">
            购买须知 >
          </div>

          <div style="margin-top: 8px;color: #999999;font-size: 13px;">{{ params.LimitSale }}</div>

          <div style="margin-top: 16px;">
            <van-field label="购票数量" name="goodsCount" required>
              <template #input>
                <van-stepper v-model="goodsCount" :max="maxQuantity" :min="minQuantity" button-size="22" disable-input
                  theme="round" />
              </template>
            </van-field>

            <van-field :rules="[{ required: true, message: '请选择使用日期' }]" :value="useDate" clickable label="使用日期"
              name="useDate" readonly required @click="showCalendar = true" />

            <van-calendar v-model="showCalendar" :show-confirm="false" :default-date="null"
              :formatter="calendar_formatter" :max-date="scheduleMaxDate" :min-date="scheduleMinDate"
              @confirm="dateOnConfirm" />
          </div>
        </div>

        <div style="background-color: #fff;border-radius: 4px;padding: 16px;margin-top: 16px;">
          <span style="font-size: 22px;">人员</span>
          <span style="font-size: 12px;margin-left: 8px;color: #999;">
            <span>需选择</span>
            <span style="color: #ff8748;"> {{ ticketCount }} </span>
            <span>人,已选择</span>
            <span style="color: #ff8748;"> {{ contactSelectedIdList.length }} </span>
            <span>人</span>
          </span>

          <div
            style="background-color: #1E90FF;height: 45px; color:#fff;border-radius:8px;margin-top:8px;border: solid 1px #1E90FF;display: flex;align-items: center;justify-content: center"
            @click="showContactUserList()">
            <van-icon name="add" size="24" />
            &nbsp;选择/新增 人员信息
          </div>

          <div v-for="contact in contactSelectedList" :key="contact.identityId"
            style="background-color: #F0F8FF;border-radius: 8px;">
            <div style="display: flex;justify-content: space-between;align-items: center;margin-top: 8px;padding: 8px;">
              <div style="font-size: 13px;">
                <p style="font-size: 16px;">{{ contact.name }}</p>
                <p>身份证 {{ contact.cardId }}</p>
                <p>手机号 {{ contact.mobile }}</p>
              </div>
              <div>
                <van-icon color="#f00" name="delete-o" size="24" @click="removeContactSelect(contact.identityId)" />
              </div>
            </div>
          </div>

          <van-divider />

          <van-field v-model="orderContact" :rules="[{ required: true, message: '请填写联系人' }]" label="联系人"
            name="orderContact" required />
          <van-field v-model="orderMobile"
            :rules="[{ required: true, message: '请填写联系手机' }, { pattern: /^\d{11,11}$/, message: '请正确填写手机号' }]"
            label="联系手机" name="orderMobile" required />
        </div>

        <div v-if="orderExtendInfo && orderExtendInfo.length > 0"
          style="background-color: #fff;border-radius: 4px;padding: 16px;margin-top: 16px;">
          <span style="font-size: 22px;">其它信息</span>

          <div v-for="formItem in orderExtendInfo" :key="formItem.ResourceOrderExtendInfoID">
            <van-field v-if="formItem.Type === 4" v-model="formItem.value" :border="true"
              :label="formItem.OrderExtendInfoName" :name="'ext_' + formItem.ResourceOrderExtendInfoID"
              :rules="[{ required: true, message: '请填写 ' + formItem.OrderExtendInfoName }]" required
              style="    border-bottom: 1px solid #ebedf0;" />

            <van-field v-if="formItem.Type === 1" :border="true" :label="formItem.OrderExtendInfoName"
              :name="'ext_' + formItem.ResourceOrderExtendInfoID"
              :rules="[{ required: true, message: '请选择 ' + formItem.OrderExtendInfoName }]" required
              style="    border-bottom: 1px solid #ebedf0;">
              <template #input>
                <van-radio-group v-model="formItem.value" direction="horizontal">
                  <van-radio v-for="item in formItem.ResourceOrderExtendInfoItemList"
                    :key="item.ResourceOrderExtendInfoItemID"
                    :name="item.ResourceOrderExtendInfoItemID.toString() + '___' + item.Content">
                    {{ item.Content }}
                  </van-radio>
                </van-radio-group>
              </template>
            </van-field>

            <van-field v-if="formItem.Type === 2" :border="true" :label="formItem.OrderExtendInfoName"
              :name="'ext_' + formItem.ResourceOrderExtendInfoID"
              :rules="[{ required: true, message: '请选择 ' + formItem.OrderExtendInfoName }]" required
              style="    border-bottom: 1px solid #ebedf0;">
              <template #input>
                <van-checkbox-group v-model="formItem.value" direction="horizontal">
                  <van-checkbox v-for="item in formItem.ResourceOrderExtendInfoItemList"
                    :key="item.ResourceOrderExtendInfoItemID"
                    :name="item.ResourceOrderExtendInfoItemID + '___' + item.Content" style="margin-top: 8px;">
                    {{ item.Content }}
                  </van-checkbox>
                </van-checkbox-group>
              </template>
            </van-field>
          </div>
        </div>
      </div>
    </van-form>

    <div class="box4 flex-row col-center row-end">
      <div class="flex-row">
        <div class="flex-row col-center">
          <span style="font-size: 15px">合计 : <span style="color: #ff7800; font-size: 12px"></span>
            <span style="color: #ff7800">{{ orderAmount }}</span></span>
        </div>
        <div v-if="contactSelectedIdList.length === ticketCount && orderAmount > 0" class="text-center ml8"
          style="height: 50px;width: 115px;  background-color: #fc3f3f;    color: white; line-height: 50px;"
          @click="on_click_pay"> 支付订单 </div>
        <div v-else style="height: 50px;width: 115px;background-color: #cccccc;color: white;line-height: 50px;"
          class="text-center ml8"> 支付订单 </div>
      </div>
    </div>

    <van-popup v-model="noticeShow" :style="{ height: '50%', padding: '8px', fontSize: '12px' }" closeable
      position="bottom">
      <div v-for="(notice, index) in noticeInfo" :key="index" style="text-align: left;">
        <p style="font-weight: bold;font-size: 21px;">{{ index }}</p>
        <div v-for="(subNotice, sindex) in notice" :key="sindex" style="">
          <p style="">
            <van-tag color="#ff7700" plain size="medium">{{ sindex }}</van-tag>
          </p>
          <ul>
            <li v-for="(subContent, i) in subNotice" :key="i" style="margin-left: 8px;line-height: 25px;">
              {{ subContent }}
            </li>
          </ul>
        </div>
        <div style="height: 1px; background-color: #999; transform:scaleY(0.5);margin: 16px 4px"></div>
      </div>
    </van-popup>

    <van-popup v-model="contactListManageShow" :style="{ height: '80%', fontSize: '12px' }" closeable position="bottom">
      <div style="text-align: center;height: 30px;font-size: 18px;padding: 8px;">选择人员</div>
      <div style="margin: 4px;background-color: #EDF0F5;">

        <van-notice-bar :scrollable="false"
          :text="'请选择：' + contactSelectedIdList.length + '个人员(' + contactSelectedIdList.length + '/' + ticketCount + ')'">
          <template #right-icon>
            <van-button size="small" type="info" @click="contactListManageShow = false"> 确 认</van-button>
          </template>
        </van-notice-bar>

        <div style="width: 100%;display: flex;justify-content: center;">
          <div
            style="background-color: #fff;height: 45px; color:#1E90FF;border-radius:8px;display: flex;align-items: center;justify-content: center;margin: 8px 0;width: 90%;font-size: 18px"
            @click="contactManage">
            <van-icon name="add" />
            &nbsp;新增人员信息
          </div>
        </div>
        <van-checkbox-group v-model="contactSelectedIdList" :max="ticketCount" @change="contactListChange">
          <van-cell v-for="contact in contactList" :key="contact.identityId" :label="'身份证 ' + contact.cardId">
            <template #title>
              <van-checkbox :name="contact.identityId">{{ contact.name }}</van-checkbox>
            </template>

            <template #default>
              <van-icon color="#1E90FF" name="edit" size="24" @click="editContactInfo(contact)" />
            </template>
          </van-cell>
        </van-checkbox-group>
      </div>
    </van-popup>

    <van-popup v-model="contactEditShow" :style="{ height: '50%', fontSize: '12px', backgroundColor: '#EDF0F5' }"
      closeable position="bottom">
      <div style="text-align: center;height: 30px;font-size: 18px;padding: 8px;">编辑游客信息</div>
      <div style="background-color: #EDF0F5;padding: 8px;border-radius: 8px;">
        <van-form ref="contactForm" @submit="saveContactInfo">
          <van-field v-model="cardType" label="证件类型" name="cardType" readonly required />
          <van-field v-model="username" :rules="[{ required: true, message: '请填写 姓名' }]" label="姓名" name="username"
            required />
          <van-field v-model="cardId"
            :rules="[{ required: true, message: '请填写 证件号码' }, { pattern: /^(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)$/, message: '请正确填写身份证号' }]"
            label="证件号码" name="cardId" required />
          <van-field v-model="mobile"
            :rules="[{ required: true, message: '请填写 电话号码' }, { pattern: /^\d{11,11}$/, message: '请正确填写手机号' }]"
            label="电话号码" name="mobile" required type="tel" />
        </van-form>
        <div style="margin: 16px;display: flex;justify-content: center;height: 60px;">
          <van-button round size="small" style="width: 80px" type="info" @click="$refs.contactForm.submit()">保 存
          </van-button>
          <van-button v-if="identityId > 0" round size="small" style="width: 80px;margin-left: 8px;" type="danger"
            @click="removeContactInfo">删除
          </van-button>
        </div>
      </div>
    </van-popup>

  </div>
</template>

<script>
import request from "@/util/axios";
import { api_ctrip_order_create_check, api_get_ctrip_goods_stock, api_get_goods_by_id } from "@/api/goods-api";
import Moment from "moment";
import { addIdentity, deleteIdentity, getUserIdentityList, modifyIdentity } from "@/api/user";
import { Dialog, Toast } from "vant";
import { GOODS_TYPE_TRAVEL, ORDER_TYPE_TRAVEL } from "@/api/constant";
import { ORDER_INFO_CACHE_KEY } from "@/util/XiZhangUtil"

export default {
  name: "travel-order",

  data() {
    return {
      goodsInfo: {},
      goodsCount: 0,
      useDate: '',
      scheduleList: [],
      showCalendar: false,
      scheduleMinDate: new Date(),
      scheduleMaxDate: Moment(new Date()).add(60, 'days').toDate(),
      noticeInfo: {},
      noticeShow: false,
      params: {},
      noteInfo: '',
      isShowMore: false,
      maxQuantity: 1,
      minQuantity: 1,
      orderMobile: '',
      orderContact: '',
      contactSelectedList: [],
      contactSelectedIdList: [],
      contactList: [],
      contactListManageShow: false,
      contactEditShow: false,
      cardId: '',
      mobile: '',
      username: '',
      cardType: '身份证',
      identityId: 0,
      orderExtendInfo: [],
      goodsPrice: 0,
      salePrice: 0,
      extFormValidate: false,
      formUseDate: '',
    }
  },

  created() {
    document.title = '创建订单 门票'

    this.orderMobile = this.$store.getters.userInfo.mobile;

    const lyp_sn = this.$route.query.lyp_sn;
    if (lyp_sn) {
      this.lyp_goods_by_sn()
      return
    }

    this.goods_by_id()
  },

  computed: {
    orderAmount: function () {
      return this.calc(this.goodsPrice, this.goodsCount, '*')
    },

    ticketCount: function () {
      budo_log.info("#308 ticketCount", this.params.UnitQuantity, this.goodsCount)

      // 这里 UnitQuantity 给了个默认值
      return parseInt(this.params.UnitQuantity || 1, 10) * parseInt(this.goodsCount, 10);
    }
  },

  methods: {
    lyp_goods_by_sn() {
      const lyp_sn = this.$route.query.lyp_sn
      const brand_shop_id = this.$route.query.brand_shop_id
      request.post_form("/mall/wx/lyp_goods_by_sn", {
        lyp_sn,
        brand_shop_id
      }).then(res => {
        this.goodsInfo = res.data || {}

        this.get_stock({ data: this.goodsInfo }, null, lyp_sn)
      })
    },

    goods_by_id() {
      const goodsId = this.$route.query.goodsId;

      api_get_goods_by_id(goodsId).then(res => {
        budo_log.info("#287 api_get_goods_by_id", goodsId, res)

        this.goodsInfo = res.data;
        this.params = JSON.parse(res.data.params) || {};
        this.noteInfo = "适用人群：" + this.params.UseNotice;
        if (this.noteInfo.length > 10) {
          this.isShowMore = true;
        }

        this.maxQuantity = this.params.MaxQuantity;
        this.minQuantity = this.params.MinQuantity;

        this.orderExtendInfo = this.params.orderExtendInfo;
        budo_log.info('#328 orderExtendInfo', this.orderExtendInfo)

        // 携程资源ID 查询排期 自营旅游产品 用goodsId查
        this.get_stock(res, goodsId, null)
      })
    },

    get_stock(res, goodsId, lyp_sn) {
      api_get_ctrip_goods_stock(res.data.sn, goodsId, lyp_sn).then(stockRes => {
        budo_log.info("#300 api_get_ctrip_goods_stock", stockRes)

        this.scheduleList = stockRes.data

        // 没有排期信息 错误提示
        if (!stockRes.data || stockRes.data.length < 1) {
          Dialog.alert({ message: stockRes.msg || "没有排期信息" })
          return
        }

        // 如果只有一个日期 就直接选中
        if (stockRes.data.length < 2) {
          this.useDate = stockRes.data[0].Date
          this.goodsPrice = res.data.price / 100 // 从商品上取价格
        }
      })
    },

    on_click_pay() {
      this.$refs.orderForm.submit(); // @see orderFormOnSubmit
    },

    lyp_new_order_dto(extInfo) {
      var goods_info = Object.fromEntries(Object.entries(this.goodsInfo).filter(([_, value]) => value != null))
      extInfo._lyp_goods_info_ = goods_info

      return {
        goodsType: 'TRAVEL_LYP',
        orderType: 'TRAVEL_LYP',
        isPackageGoods: 0,
        total: this.orderAmount,
        cityCode: this.$store.getters.city_code,
        expressFee: 0,
        orderFee: this.calc(this.orderAmount, 100, '*'),
        userAddressId: 0,
        userDescription: '',
        extInfo: JSON.stringify(extInfo),
        timeId: new Date().getTime(),
        cateCode: '0007',
      }
    },

    prepare_new_order_dto(extInfo) {
      if (this.$route.query.lyp_sn) {
        return this.lyp_new_order_dto(extInfo)
      }

      return {
        goodsType: GOODS_TYPE_TRAVEL,
        isPackageGoods: 0,
        total: this.orderAmount,
        cityCode: this.$store.getters.city_code,
        expressFee: 0,
        orderFee: this.calc(this.orderAmount, 100, '*'),
        userAddressId: 0,
        userDescription: '',
        extInfo: JSON.stringify(extInfo),
        orderType: ORDER_TYPE_TRAVEL,
        goodsList: [
          {
            goods: {
              goodsId: this.goodsInfo.goodsId,
              name: this.goodsInfo.name,
              price: this.calc(this.goodsPrice, 100, '*'),
              img: this.goodsInfo.headImage,
              cateCode: this.goodsInfo.cateCode,
              spec: [],
              goodsType: GOODS_TYPE_TRAVEL,
              identityAuth: false,
              payWxMin: 0
            },
            checked: true,
            count: this.goodsCount
          }],
        timeId: new Date().getTime(),
        cateCode: '0007',
      }
    },

    orderFormOnSubmit(values) {
      budo_log.info('#350 orderFormOnSubmit', values)

      const addInfos = [];
      for (const dataKey in values) {
        if (dataKey.substring(0, 4) === 'ext_') {
          const AddInfoDetails = [];
          const value = values[dataKey];
          if (Array.isArray(value)) {
            for (const itemValue of value) {
              const vs = itemValue.toString().split('___');
              AddInfoDetails.push({ ID: vs[0], Content: vs[1] })
            }
          } else {
            if (value.toString().indexOf('___') > 0) {
              const vs = value.toString().split('___');
              AddInfoDetails.push({ ID: vs[0], Content: vs[1] })
            } else {
              AddInfoDetails.push({ ID: 1, Content: value })
            }
          }
          addInfos.push({
            ResourceOrderExtendInfoID: dataKey.substring(4),
            AddInfoDetails: AddInfoDetails
          })
        }
      }

      const extInfo = {
        mobile: values.orderMobile,
        name: values.orderContact,
        orderAmount: this.calc(this.salePrice, this.goodsCount, '*'),

        passengerInfoList: this.contactSelectedList.map(c => {
          return {
            Cname: c.name,
            ResourceID: +this.goodsInfo.sn,
            IdCardNo: c.cardId,
            ContactInfo: c.mobile,
            IdCardType: 1
          }
        }),

        resList: [{
          ResourceID: +this.goodsInfo.sn,
          goodsId: this.goodsInfo.goodsId,
          UseDate: this.formUseDate,
          Quantity: this.goodsCount,
          Price: this.salePrice,
          ItemAddInfos: addInfos
        }]
      };

      if (this.$route.query.lyp_sn) {
        this.up_order_info_go_pay(extInfo)
        return
      }

      api_ctrip_order_create_check(extInfo).then(res => {
        if (!res.data.IsSuccess) {
          Dialog.confirm({ message: res.data.CustomerErrorMessage })
          return
        }

        this.up_order_info_go_pay(extInfo)
      });
    },

    up_order_info_go_pay(extInfo) {
      const updateOrderInfo = this.prepare_new_order_dto(extInfo)
      budo_log.info('#406 api_ctrip_order_create_check, updateOrderInfo=', updateOrderInfo)

      if ('v2.rongchuangfuli.com' == location.host) {
        this.$store.dispatch("actions_updateOrderInfo", updateOrderInfo).then(() => {
          this.go_select_card_pay()
        })
        return
      }

      console.log("#495 up_order_info_go_pay, updateOrderInfo", updateOrderInfo)

      // 写新版数据
      sessionStorage.setItem(ORDER_INFO_CACHE_KEY, JSON.stringify(updateOrderInfo)); // 缓存一手

      var queryString = "?orderMode=0"
        + "&goodsType=" + (this.$route.query.lyp_sn ? 'TRAVEL_LYP' : GOODS_TYPE_TRAVEL)
        + "&cateId=7"
        + "&topicId=0"

      location.href = "/v6/select-card-pay" + queryString
    },

    go_select_card_pay() {
      this.$router.push({
        path: "/select-card-pay",
        query: {
          orderMode: '0',
          goodsType: this.$route.query.lyp_sn ? 'TRAVEL_LYP' : GOODS_TYPE_TRAVEL,
          cateId: '7',
          topicId: 0
        }
      });
    },

    contactListChange(ids) {
      this.contactSelectedList = [];
      if (ids && ids.length > 0) {
        budo_log.info('#456 contactListChange', ids)

        for (const id of ids) {
          budo_log.info('#458 contactListChange', id)
          const contact = this.contactList.find(c => c.identityId === id);
          this.contactSelectedList.push(contact);
        }
      }
    },

    removeContactSelect(identityId) {
      const index = this.contactSelectedList.findIndex(c => c.identityId === identityId);
      this.contactSelectedList.splice(index, 1);

      const idIndex = this.contactSelectedIdList.findIndex(c => c.identityId === identityId);
      this.contactSelectedIdList.splice(idIndex);
    },

    contactManage() {
      this.contactEditShow = true;
      this.cardId = ''
      this.mobile = ''
      this.username = ''
      this.identityId = 0
    },

    editContactInfo(info) {
      this.identityId = info.identityId;
      this.cardId = info.cardId;
      this.mobile = info.mobile;
      this.username = info.name;
      this.contactEditShow = true;
    },

    saveContactInfo() {
      const data = { mobile: this.mobile, name: this.username, cardId: this.cardId };
      if (this.identityId > 0) {
        data.identityId = this.identityId;
        modifyIdentity(data).then(res => {
          if (res.code === 0) {
            this.saveSuccess();
          } else {
            Toast.fail(res.msg)
          }
        })
      } else {
        addIdentity(data).then(res => {
          if (res.code === 0) {
            this.saveSuccess();
          } else {
            Toast.fail(res.msg)
          }
        })
      }
    },

    removeContactInfo() {
      deleteIdentity(this.identityId).then(res => {
        if (res.code === 0) {
          this.saveSuccess();

          this.cardId = ''
          this.mobile = ''
          this.username = ''
          this.identityId = 0
        } else {
          Toast.fail(res.msg)
        }
      })
    },

    saveSuccess() {
      Toast.success('操作成功')
      this.contactEditShow = false;
      getUserIdentityList().then(res => {
        this.contactList = res.data;
      });
    },

    showContactUserList() {
      this.contactListManageShow = true
      getUserIdentityList().then(res => {
        this.contactList = res.data;
      });
    },

    dateOnConfirm(date) {
      this.useDate = `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
      this.formUseDate = Moment(date).format('YYYY-MM-DD');
      this.showCalendar = false;

      const dd = this.scheduleList.find(s => Moment(s.Date).format('YYYY-MM-DD') === Moment(date).format('YYYY-MM-DD'));
      this.goodsPrice = dd.CtripPrice;
      this.salePrice = dd.Price;
    },

    calendar_formatter(day) {
      const dd = this.scheduleList.find(s => Moment(s.Date).format('YYYY-MM-DD') === Moment(day.date).format('YYYY-MM-DD'));
      if (dd) {
        if (dd.InventoryNum > 0) {
          day.bottomInfo = dd.CtripPrice + "豆";
        } else {
          day.type = 'disabled';
        }
      } else {
        day.type = 'disabled';
      }

      return day;
    },

    showNotice() {
      this.noticeShow = true;
      const goodsInfo = JSON.parse(this.goodsInfo.notice);
      const keysSorted = Object.keys(goodsInfo).sort((a, b) => {
        return a.substring(0, 1) - b.substring(0, 1);
      });

      for (let i = 0; i < keysSorted.length; i++) {
        this.noticeInfo[keysSorted[i].substring(1)] = goodsInfo[keysSorted[i]];
      }
    },

    showMoreDesc(e) {
      let el = e.currentTarget;
      el.previousElementSibling.classList[!this.isDescStatus ? 'add' : 'remove']('overflow-line');
      el.classList[this.isDescStatus ? 'add' : 'remove']('more-collapse');
      el.innerHTML = !this.isDescStatus ? '展开' : '收起';
      this.isDescStatus = !this.isDescStatus;
      this.isShowMore = true;
    },

    calc(num1, num2, calcStr) {
      budo_log.info("#577 calc", num1, num2, calcStr)

      let str1, // 转换为字符串的数字
        str2,
        ws1 = 0,// ws1，ws2 用来存储传入的num的小数点后的数字的位数
        ws2 = 0,// 赋默认值，解决当整数和小数运算时倍数计算错误导致的结果误差
        bigger,// bigger和smaller用于加，减，除法找出小的那个数字，给后面补0，解决位数不对从而造成的计算错误的问题；乘法需要将结果除两个数字的倍数之和
        smaller,// 例如：加减除法中1.001 + 2.03 ，如果不给2.03进行补0，最后会变成1001+203，数字错位导致结果错误；乘法中1.12*1.1会放大为112*11，所以结果需要除以1000才会是正确的结果，112*11/1000=1.232
        zeroCount, // 需要补充0的个数
        isExistDot1, // 传入的数字是否存在小数点
        isExistDot2,
        sum,
        beishu = 1;

      // 将数字转换为字符串
      str1 = num1.toString();
      str2 = num2.toString();

      // 是否存在小数点（判断需要计算的数字是不是包含小数）
      isExistDot1 = str1.indexOf('.') != -1 ? true : false;
      isExistDot2 = str2.indexOf('.') != -1 ? true : false;

      // 取小数点后面的位数
      if (isExistDot1) {
        ws1 = str1.split('.')[1].length;
      }

      if (isExistDot2) {
        ws2 = str2.split('.')[1].length;
      }

      // 如ws1 和 ws2 无默认值，如果num1 或 num2 不是小数的话则 ws1 或 ws2 的值将为 undefined
      // bigger 和 smaller 的值会和预期不符
      bigger = ws1 > ws2 ? ws1 : ws2;
      smaller = ws1 < ws2 ? ws1 : ws2;

      switch (calcStr) {
        // 加减法找出小的那个数字，给后面补0，解决位数不对从而造成的计算错误的问题
        // 例如：1.001 + 2.03 ，如果不给2.03进行补0，最后会变成1001+203，数字错位导致结果错误
        case "+":
        case "-":
        case "/":
          zeroCount = bigger - smaller;
          for (var i = 0; i < zeroCount; i++) {
            if (ws1 == smaller) {
              str1 += "0";
            } else {
              str2 += "0";
            }
          }
          break;
        case "*":
          // 乘法需要将结果除两个数字的倍数之和
          bigger = bigger + smaller;
          break;
        default:
          return "暂不支持的计算类型，现已支持的有加法、减法、乘法、除法";
      }

      // 去除数字中的小数点
      str1 = str1.replace('.', '');
      str2 = str2.replace('.', '');

      // 计算倍数，例如：1.001小数点后有三位，则需要乘 1000 变成 1001，变成整数后精度丢失问题则不会存在
      for (let i = 0; i < bigger; i++) {
        beishu *= 10; // 等价于beishu = beishu * 10;
      }

      num1 = parseInt(str1);
      num2 = parseInt(str2);

      // 进行最终计算并除相应倍数
      switch (calcStr) {
        case "+":
          sum = (num1 + num2) / beishu;
          break;
        case "-":
          sum = (num1 - num2) / beishu;
          break;
        case "*":
          sum = (num1 * num2) / beishu;
          break;
        case "/":
          sum = num1 / num2;
          /* 除数与被除数同时放大一定倍数，不影响结果，
          所以对数字进行放大对应倍数并进行补0操作后不用另对倍数做处理 */
          break;
        default:
          return "暂不支持的计算类型，现已支持的有加法、减法、乘法、除法";
      }

      return sum;
    }
  }
}
</script>

<style lang="scss" scoped>
.m-content {
  &.overflow-line {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    width: 90%;
  }
}

.btn-more {
  color: #5383E7;
}

.enter-order-page {
  padding-bottom: 120px;
  background-color: #EDF0F5;

  .content-box {
    padding: 8px;

    .box1 {
      margin-top: 100px;
      padding: 0 12px;

      .user-box {
        height: 67px;
        padding: 23px 43px;
        background: #FFFFFF;
        box-shadow: 0px 1px 5px 0px rgba(1, 1, 1, 0.1);
        border-radius: 5px;
        font-size: 12px;
      }

      .remark-input {
        border: unset;

        &::placeholder {
          color: #f0f0f0;
          font-size: 15px;
        }
      }
    }
  }

  .box4 {
    position: fixed;
    bottom: 0;
    height: 50px;
    width: 100%;
    background-color: #fff;
    border-top: solid 1px #ececec;
    box-shadow: 0 1px 5px 0 rgba(155, 155, 155, 0.5);
  }
}

.card-title {
  color: #ff0;
}


.attribute {
  display: flex;
  margin: 20px 0;

  .title {
    width: 100px;
  }

  .van-cell {
    padding: 0;
    flex: 1;
  }
}

.card-list {
  display: flex;
  align-items: center;
  margin: 16px 10px;
  position: relative;
  font-size: 14px;
  background: #fff;
  border: 1px solid #ccc;
  padding: 5px;

  &-title {
    display: inline-block;
    width: 56px;
    margin-right: 12px;
  }
}
</style>
